export const ROUTES = {
  root: '/',

  registration: '/registration/:campaignId',
  rfid: '/rfid',
  addUser: '/add-user',

  login: '/login',
  recover: '/recover',
  employees: '/employees',

  emails: '/emails',

  user: {
    profile: '/profile',
    onlineOrder: '/profile/speedy-ordering',
    menu: '/profile/menu',
  },
  employeeProfile: '/employee/:id',

  internalServerError: '/500',

  admin: {
    discounts: '/discounts',
    staffGroups: '/discounts/groups',
    campaign: '/discounts/campaigns',
    discountItem: '/discounts/item/:id?',
    employeeDiscounts: '/discounts/employee-discounts',
    employeeDiscountItem: '/discounts/employee-discounts/item/:id',
    employeeDiscountItemNew: '/discounts/employee-discounts/item',

    menuItem: '/menu-items/item/:id?',
    menuItems: '/menu-items/',
    menu: '/menu/',
    menuLines: '/menu/lines',
    plu: '/plu',
    pluItem: '/plu/item/:id',
    pluItemNew: '/plu/item',
    menuDesign: '/menu/design',
    recognition: '/recognition',
    datasets: '/recognition/datasets/',
    dataset: '/recognition/datasets/:id',
    jobs: '/recognition/jobs',
    tasks: '/recognition/tasks',
    task: '/recognition/tasks/task',
    models: '/recognition/models',
    deployments: '/recognition/deployments',
    agents: '/recognition/agents',

    live: '/live',
    report: '/report',
    revenue: '/report/revenue',
    subsidy: '/report/subsidy',
    storno: '/report/storno',
    item: '/report/item',
    tips: '/report/tips',
    stocklist: '/report/stocklist',
    feedback: '/report/feedback',
    feedbackMenuItems: '/report/feedback/items',
    meeting: '/meeting',

    settings: '/settings',
    config: '/settings/config',
    startScreenDesigner: '/settings/start-screen',
    startScreenDesignerText: '/settings/start-screen/text',
    startScreenDesignerLogo: '/settings/start-screen/logo',
    banners: '/settings/banners',
  },
  archiveAdmin: {
    archive: '/archive',
  },
  service: '/online-orders',
  stocklist: '/stocklist',
};
